import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';

import { ToastProvider } from '@/components/ui/Toast';

import { createQueryClient } from './query-client';

export interface AppProvidersProps {
  children: ReactNode;
}

/** Every app-wide provider lives here, so `App.tsx` stays a one-liner. */
export function AppProviders({ children }: AppProvidersProps) {
  // useState so the client survives re-renders but is never shared between tests.
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>{children}</ToastProvider>
    </QueryClientProvider>
  );
}
